module.exports = __webpack_public_path__ + "static/pid-ug-18-en-authrequest-5f55c2edf626269d249d6376c2454905.png";